import { AEO_HUBS, articlesForIcp } from './aeoArticlesData';

const SITE = 'https://diligentsia.co.uk';

// WebPage schema for an ICP hub page, listing its AEO article cluster (hub-and-spoke).
export const hubWebPageSchema = (icpSlug) => {
    const hub = AEO_HUBS[icpSlug];
    if (!hub) return [];
    const articles = articlesForIcp(icpSlug);
    return [{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: `Diligentsia for ${hub['name']}`,
        url: `${SITE}${hub['hubPath']}/`,
        publisher: { '@type': 'Organization', name: 'Diligentsia', url: SITE },
        hasPart: articles.map(a => ({ '@type': 'Article', headline: a['title'], url: a['url'] })),
    }];
};

export default hubWebPageSchema;
